(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mkn-sale-banner"]) return;
  try {
    
  if (!customElements.get('mkn-sale-banner')) {
    customElements.define('mkn-sale-banner', class extends HTMLElement {
      connectedCallback() {
        this.active = true;
        this.hidden = true;
        if (this.dataset.editorPreview === 'true') {
          this.hidden = false;
          return;
        }
        this.start = Date.parse(this.dataset.start);
        this.end = Date.parse(this.dataset.end);
        this.onResume = () => {
          this.hidden = true;
          if (!document.hidden) this.syncClock();
        };
        document.addEventListener('visibilitychange', this.onResume);
        window.addEventListener('pageshow', this.onResume);
        this.syncClock();
      }
      async syncClock() {
        if (!this.active || this.syncing) return;
        clearTimeout(this.syncTimer);
        this.syncing = true;
        this.controller = new AbortController();
        const timeout = setTimeout(() => this.controller.abort(), 8000);
        try {
          const sent = performance.now();
          const response = await fetch(this.dataset.clockUrl + '?mkn_sale_clock=' + Math.random().toString(36).slice(2), {
            cache: 'no-store', credentials: 'same-origin', signal: this.controller.signal
          });
          const received = performance.now();
          const serverTime = Date.parse(response.headers.get('Date') || '');
          const age = Number(response.headers.get('Age') || 0);
          if (!response.ok || !Number.isFinite(serverTime) || age > 0) throw new Error('Clock unavailable');
          if (!this.active) return;
          this.serverTime = serverTime;
          this.syncedAt = received;
          this.uncertainty = 1000 + received - sent;
          this.dataset.clockStatus = 'synced';
          this.updateVisibility();
        } catch (error) {
          this.hidden = true;
          this.serverTime = undefined;
          this.dataset.clockStatus = 'unavailable';
        } finally {
          clearTimeout(timeout);
          this.syncing = false;
          if (this.active) this.syncTimer = setTimeout(() => this.syncClock(), 60000);
        }
      }
      updateVisibility() {
        clearTimeout(this.boundaryTimer);
        if (!this.active || !Number.isFinite(this.serverTime)) {
          this.hidden = true;
          return;
        }
        const elapsed = performance.now() - this.syncedAt;
        const lowerTime = this.serverTime + elapsed;
        const upperTime = lowerTime + this.uncertainty;
        this.hidden = document.hidden || elapsed > 70000 || lowerTime < this.start || upperTime >= this.end;
        const untilBoundary = lowerTime < this.start ? this.start - lowerTime : this.end - upperTime;
        if (untilBoundary > 0) this.boundaryTimer = setTimeout(() => this.updateVisibility(), Math.min(untilBoundary, 1000));
      }
      disconnectedCallback() {
        this.active = false;
        this.controller?.abort();
        clearTimeout(this.syncTimer);
        clearTimeout(this.boundaryTimer);
        document.removeEventListener('visibilitychange', this.onResume);
        window.removeEventListener('pageshow', this.onResume);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["plusm-sale-banner"]) return;
  try {
    

  if (!customElements.get('plusm-sale-banner')) {
    customElements.define('plusm-sale-banner', class extends HTMLElement {
      connectedCallback() {
        this.active = true;
        this.hidden = true;
        if (this.dataset.editorPreview === 'true') {
          this.hidden = false;
          return;
        }
        this.start = Date.parse(this.dataset.start);
        this.end = Date.parse(this.dataset.end);
        this.onResume = () => {
          this.hidden = true;
          if (!document.hidden) this.syncClock();
        };
        document.addEventListener('visibilitychange', this.onResume);
        window.addEventListener('pageshow', this.onResume);
        this.syncClock();
      }
      async syncClock() {
        if (!this.active || this.syncing) return;
        clearTimeout(this.syncTimer);
        this.syncing = true;
        this.controller = new AbortController();
        const timeout = setTimeout(() => this.controller.abort(), 8000);
        try {
          const sent = performance.now();
          const response = await fetch(this.dataset.clockUrl + '?mkn_sale_clock=' + Math.random().toString(36).slice(2), {
            cache: 'no-store', credentials: 'same-origin', signal: this.controller.signal
          });
          const received = performance.now();
          const serverTime = Date.parse(response.headers.get('Date') || '');
          const age = Number(response.headers.get('Age') || 0);
          if (!response.ok || !Number.isFinite(serverTime) || age > 0) throw new Error('Clock unavailable');
          if (!this.active) return;
          this.serverTime = serverTime;
          this.syncedAt = received;
          this.uncertainty = 1000 + received - sent;
          this.dataset.clockStatus = 'synced';
          this.updateVisibility();
        } catch (error) {
          this.hidden = true;
          this.serverTime = undefined;
          this.dataset.clockStatus = 'unavailable';
        } finally {
          clearTimeout(timeout);
          this.syncing = false;
          if (this.active) this.syncTimer = setTimeout(() => this.syncClock(), 60000);
        }
      }
      updateVisibility() {
        clearTimeout(this.boundaryTimer);
        if (!this.active || !Number.isFinite(this.serverTime)) {
          this.hidden = true;
          return;
        }
        const elapsed = performance.now() - this.syncedAt;
        const lowerTime = this.serverTime + elapsed;
        const upperTime = lowerTime + this.uncertainty;
        this.hidden = document.hidden || elapsed > 70000 || lowerTime < this.start || upperTime >= this.end;
        const untilBoundary = lowerTime < this.start ? this.start - lowerTime : this.end - upperTime;
        if (untilBoundary > 0) this.boundaryTimer = setTimeout(() => this.updateVisibility(), Math.min(untilBoundary, 1000));
      }
      disconnectedCallback() {
        this.active = false;
        this.controller?.abort();
        clearTimeout(this.syncTimer);
        clearTimeout(this.boundaryTimer);
        document.removeEventListener('visibilitychange', this.onResume);
        window.removeEventListener('pageshow', this.onResume);
      }
    });
  }


  } catch(e) { console.error(e); }
})();
})();
